import RequestStatus from 'types/general/requests/RequestStatus';
import { createSlice } from '@reduxjs/toolkit';
import { GenericDataState, createSetFetchDataPendingReducer, createSetFetchDataSuccesReducer, createSetFetchDataErrorReducer } from '../generic/GenericDataReducers';
import { IDocument } from 'types/backend_models/documents/IDocument';
import { ITableData } from 'types/backend_models/shared/ITableData';

const initialState: GenericDataState<ITableData<IDocument[]>> = {
	requestStatus: RequestStatus.idle,
	data: {
		results: [],
		currentPage: 1,
		pageCount: 0,
		pageSize: 1000,
		rowCount: 0
	},
	error: null
};

/* SLICE */
const slice = createSlice({
	name: "orderDocuments",
	initialState: initialState,
	reducers: {
		setFetchOrderDocumentsPending: createSetFetchDataPendingReducer(),
		setFetchOrderDocumentsSucces: createSetFetchDataSuccesReducer(),
		setFetchOrderDocumentsError: createSetFetchDataErrorReducer()
	}
});

export const {
	setFetchOrderDocumentsPending,
	setFetchOrderDocumentsSucces,
	setFetchOrderDocumentsError
} = slice.actions;

export { initialState };
export default slice.reducer;